export const heroBanners = [
  {
    id: "all-night-wrong",
    title: "All Night Wrong",
    tagline: "One night. Everything goes wrong.",
    genre: "Comedy Thriller",
    year: "2026",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7B4b9fe832-0bde-ed11-8297-0e4a64f8a357%7D/Screenshot%202026-09-04%20at%2011.12.56%E2%80%AFAM_%7Becb5d146-8ca8-f111-82ac-0e4a64f8a357%7D.png",
  },
  {
    id: "couples-weekend",
    title: "Couples Weekend",
    tagline: "Four friends. One chaotic getaway.",
    genre: "Comedy Romance",
    year: "2026",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7B658c4b66-1a92-ed11-8296-0e4a64f8a357%7D/Screenshot%202026-05-14%20at%2010.42.17%E2%80%AFAM_%7Bc4b5a21c-bc4f-f111-82ab-0e4a64f8a357%7D.png",
  },
  {
    id: "safe-house",
    title: "Safe House",
    tagline: "Trust no one. Nowhere is safe.",
    genre: "Action Thriller",
    year: "2025",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7Bdf73ec3d-2a79-e511-9487-0e563b5fb261%7D/Screenshot%202025-10-13%20at%203.25.13%E2%80%AFPM_%7B8623bd06-84a8-f011-82a9-0e4a64f8a357%7D.png",
  },
  {
    id: "stolen-girl",
    title: "Stolen Girl",
    tagline: "A mother's desperate hunt for the truth.",
    genre: "Thriller Drama",
    year: "2025",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7B32f62ae6-8b02-ef11-82a0-0e4a64f8a357%7D/Screenshot%202025-10-13%20at%203.03.22%E2%80%AFPM_%7B9242cf5c-80a8-f011-82a9-0e4a64f8a357%7D.png",
  },
  {
    id: "frontier-crucible",
    title: "Frontier Crucible",
    tagline: "You don't have to die to go to hell.",
    genre: "Western Action",
    year: "2025",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7B21377752-3a72-ec11-828b-0e415c66ce57%7D/Screenshot%202025-10-13%20at%203.19.59%E2%80%AFPM_%7Bd122edc3-82a8-f011-82a9-0e4a64f8a357%7D.png",
  },
  {
    id: "under-fire",
    title: "Under Fire",
    tagline: "Two legends. One last score.",
    genre: "Action Comedy",
    year: "2025",
    image:
      "https://s3.amazonaws.com/cdn.filmtrackonline.com/c01146/starcm_vault_root/images/%7B559ef706-43d5-ec11-828f-0e415c66ce57%7D/Screenshot%202025-08-13%20at%205.06.26%E2%80%AFPM_%7B56fdec32-a178-f011-82a7-0e4a64f8a357%7D.png",
  },
];